import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useSelector } from "react-redux";
import { NavLink as RouteNavLink } from "react-router-dom";
import { Container, Row, Navbar, Nav, NavItem, NavLink, Col } from "shards-react";
import RetinaImage from 'react-retina-image';

import NavbarSearch from "./NavbarSearch";
import NavbarNav from "./NavbarNav/NavbarNav";
import NavbarToggle from "./NavbarToggle";

import { APP_VERSION } from "../../../core/constants";

const MainNavbar = ({ layout, stickyTop, show_menu }) => {
const { provider } = useSelector( state => state);

  const classes = classNames(
    "collapse",
    "navbar-collapse",
    "justify-content-md-end",
    "bg-white",
    show_menu && "show"
  );
  return (
    <div className="main-navbar bg-white pt-3 no-shadow">
    <Container fluid={true} >

    <Navbar type="light" className="flex-md-nowrap p-0 navbar-expand-md">

    <div className="navbar-brand py-0">
		<div className="d-flex align-items-center">
			<RouteNavLink className="d-none d-lg-block mr-4" to="/home" style={{ 'marginBottom':'3px' }}>
				<RetinaImage id="main-logo" src={[require("../../../images/logo-GALENO.png"), require("../../../images/logo-GALENO@2x.png")]} alt="Galeno" height="29px"/>
			</RouteNavLink>
			<div className="border-left d-none d-lg-flex align-items-center mr-2 pr-1 pl-4">
				<RetinaImage
					src={[require("../../../images/iso_cuidadosDomiciliarios.png"), require("../../../images/iso_cuidadosDomiciliarios@2x.png")]}
					alt="Galeno"
					height="35px"
					width="31px"
					className="align-middle"
				/>
			</div>

			<div>
				<h4 className="my-0 text-primary pt-3" >Cuidados Domiciliarios</h4>
				<div className="d-flex align-items-end">
					<small className="text-secondary">v{APP_VERSION} / {provider.get('version')}</small>
				</div>
			</div>
		</div>
	</div>

    <NavbarToggle />

		<div className={classes} id="navbar">
			<Nav className="main-navbar__menu flex-column flex-md-row">
				<NavItem>
					<NavLink tag={RouteNavLink} className="text-nowrap mx-3" to="/home">
						<div className="d-inline-block"><i className="material-icons">view_day</i></div>Ordenes
					</NavLink>
				</NavItem>
				<NavItem className="border-left">
					<NavLink tag={RouteNavLink} className="text-nowrap mx-3" to="/efectores">
						<div className="d-inline-block"><i className="material-icons">table_chart</i></div>Efectores
					</NavLink>
				</NavItem>
			</Nav>
			<NavbarNav />
		</div>
        </Navbar>
      </Container>
    </div>
  );
};

MainNavbar.propTypes = {
  /**
   * The layout type where the MainNavbar is used.
   */
  layout: PropTypes.string,
  /**
   * Whether the main navbar is sticky to the top, or not.
   */
  stickyTop: PropTypes.bool,

  show_menu: PropTypes.bool,
};

MainNavbar.defaultProps = {
  stickyTop: false,
  show_menu: false
};

export default MainNavbar;
